import type { Tier } from '@/api/me';

/** The role line under the display name (§14.3), per tier — the bar at `md`+ and the account menu. */
export const ROLE_KEY: Record<Tier, string> = {
  SUBSCRIBER: 'shell.roleSubscriber',
  GUEST: 'shell.roleGuest',
  NONE: 'shell.roleNone',
};

/** A served trial replaces the subscriber role with "Owner · free trial". */
export function roleLabelKey(tier: Tier, trialEndsOn: string | null): string {
  if (tier === 'SUBSCRIBER' && trialEndsOn !== null && trialEndsOn.length > 0) {
    return 'shell.roleTrial';
  }
  return ROLE_KEY[tier];
}
